import { writable } from 'svelte/store';
let progressCount = 0;
export const createProgressStore = () => {
    const progressState = { isActive: false };
    const { subscribe, set } = writable(progressState);
    const start = () => {
        progressCount++;
        set({ isActive: true });
    };
    const finish = () => {
        progressCount--;
        set({ isActive: !!progressCount });
    };
    return {
        subscribe,
        start,
        finish,
    };
};
